// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-29a7eec2] h1{line-height:normal;margin-bottom:30px}[data-v-29a7eec2] h2{line-height:normal;margin-top:10px;margin-bottom:5px}[data-v-29a7eec2] .v-data-table.theme--light,[data-v-29a7eec2] .v-tabs-items{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
